<template>
  <div :class="$style.frameGroup">
    <h2>{{ title }}</h2>
    <div :class="$style.frameContainer">
      <div :class="$style.formGroup">
        <div>How many hours of flight experience do you have?</div>
        <input
          type="number"
          v-model="form.flightHours"
          placeholder="Type hours..."
        />
      </div>
      <div :class="$style.formGroup">
        <div>Which of these ratings do you have?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.ratings"
          multi-select
          :options="ratingsList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>What Medical Certificate do you hold?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.medicalCertificateId"
          :options="medicalCertificatesList"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>What is your primary role at the flight school?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.flightSchoolRoles"
          multi-select
          :options="flightSchoolRolesList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>What or who inspired you to pursue a career in aviation?</div>
        <input
          type="text"
          v-model="form.whoInspired"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>
          What are your long term goals both within and outside of aviation?
        </div>
        <input
          type="text"
          v-model="form.longTermGoals"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>How do you handle challenges or setbacks?</div>
        <input
          type="text"
          v-model="form.handleChallenges"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>What is the highest level of education you have achieved?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.educationLevelId"
          :options="educationLevelsList"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>What is your experience with flight school management?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.managementExperienceId"
          :options="managementExperienceList"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>Do you currently have any airline partnerships?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.currentAirlinePartnerships"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>If yes, which airlines are you partnered with?</div>
        <input
          type="text"
          v-model="form.airlinesPartneredWith"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>Are you interested in developing new airline partnerships?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.newAirlinePartnerships"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>Do you work with any lenders for student financing?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.currentLenders"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>If yes, which lenders do you currently work with?</div>
        <input
          type="text"
          v-model="form.lendersPartneredWith"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>Are you looking to establish new lender relationships?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.newLenders"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>Do you use any software to manage operations?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.flightSchoolTools"
          multi-select
          :options="flightSchoolToolsList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>What is the size of your flight school?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.flightSchoolSizeId"
          :options="flightSchoolSizeList"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.buttonContainer">
        <div :class="$style.nextButton" @click="handleNext">
          <b :class="$style.name">Next</b>
        </div>
        <div :class="$style.backButton" @click="$emit('onPrev')">
          <b :class="$style.name">Back</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import AboutYouAPIService from "@/servicehandlers/AboutYouAPIService";
const aboutYouAPIService = new AboutYouAPIService();
export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  components: {
    HiloSelect,
  },
  data() {
    return {
      form: {
        flightHours: "",
        ratings: [],
        medicalCertificateId: "",
        flightSchoolRoles: [],
        whoInspired: "",
        handleChallenges: "",
        longTermGoals: "",
        educationLevelId: "",
        managementExperienceId: "",
        currentAirlinePartnerships: "",
        airlinesPartneredWith: "",
        newAirlinePartnerships: "",
        currentLenders: "",
        lendersPartneredWith: "",
        newLenders: "",
        flightSchoolTools: [],
        flightSchoolSizeId: "",
      },
      ratingsList: [],
      medicalCertificatesList: [],
      educationLevelsList: [],
      flightSchoolRolesList: [],
      flightSchoolToolsList: [],
      managementExperienceList: [],
      flightSchoolSizeList: [],
      loading: false,
    };
  },
  mounted() {
    this.getAboutYouLists();
  },
  methods: {
    async getAboutYouLists() {
      try {
        [
          this.educationLevelsList,
          this.flightSchoolRolesList,
          this.flightSchoolToolsList,
          this.ratingsList,
          this.medicalCertificatesList,
          this.managementExperienceList,
          this.flightSchoolSizeList,
        ] = await Promise.all([
          aboutYouAPIService.getEducationLevelsList(),
          aboutYouAPIService.getFlightSchoolRolesList(),
          aboutYouAPIService.getFlightSchoolToolsList(),
          aboutYouAPIService.getRatingsList(),
          aboutYouAPIService.getMedicalCertificatesList(),
          aboutYouAPIService.getManagementExperienceList(),
          aboutYouAPIService.getFlightSchoolSizeList(),
        ]);
        this.flightSchoolRolesList = this.flightSchoolRolesList.filter(
          (role) => role.aboutYouOwner,
        );
        this.ratingsList = this.ratingsList.filter(
          (rating) => rating.aboutYouOwner,
        );
        this.flightSchoolToolsList = this.flightSchoolToolsList.filter(
          (role) => role.aboutYouOwner,
        );
      } catch (error) {}
    },
    async handleNext() {
      try {
        this.loading = true;
        const aboutYouData = {
          ...this.form,
          currentAirlinePartnerships:
            this.form.currentAirlinePartnerships === "yes",
          newAirlinePartnerships: this.form.newAirlinePartnerships === "yes",
          currentLenders: this.form.currentLenders === "yes",
          newLenders: this.form.newLenders === "yes",
          userId: this.userId,
        };

        if (this.userId)
          await aboutYouAPIService.createOrUpdateOwner(aboutYouData);
        this.$emit("onNext", { aboutYou: this.form });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>

<style module scoped>
.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}
.frameGroup {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.formGroup {
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
}

.formGroup p {
  font-size: 16px;
}

.frameContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px;
}
</style>
